import React, { Component } from "react"
import PropTypes from "prop-types"

import { decodeBreadcrumbsParameters } from "../../routes"

import { injectIntl } from "react-intl"
import { getStyles } from "../../styles/dynamicStyles"
import BreadcrumbsDropdown from "../elements/BreadcrumbsDropdown"

class FilterBreadcrumbs extends Component {
  static propTypes = {
    name: PropTypes.string,
    filter: PropTypes.object,
    breadcrumbsSearch: PropTypes.string
  }

  constructor(props) {
    super(props)

    this.state = {
      breadcrumbsSearch: this.props.breadcrumbsSearch,
      breadcrumbsSubfields: [],
      breadcrumbsSubfieldIndex: 0
    }
  }

  // set initial breadcrumbs subfields
  componentDidMount() {
    const { breadcrumbsSearch } = this.props
    if (breadcrumbsSearch) this.setBreadcrumbsSubfields(breadcrumbsSearch)
  }

  // update breadcrumbs subfields when breadcrumbs search changes
  componentDidUpdate(prevProps) {
    if (this.state.breadcrumbsSearch !== prevProps.breadcrumbsSearch) {
      this.setBreadcrumbsSubfields(prevProps.breadcrumbsSearch)
    }
  }

  getBreadcrumbsFilterValue = searchParameter => {
    const decodedBreadcrumbsSearch =
      searchParameter && decodeBreadcrumbsParameters(searchParameter)
    const filterValue =
      decodedBreadcrumbsSearch && Object.values(decodedBreadcrumbsSearch)[0]

    return filterValue
  }

  getBreadcrumbsOptions = () => {
    const { filter } = this.props
    const breadcrumbsOptions = filter && filter.valid_breadcrumbs_options

    return breadcrumbsOptions
  }

  getBreadcrumbsSubfields = () => {
    const { breadcrumbsSearch } = this.props
    const selectedBreadcrumbs = this.getBreadcrumbsFilterValue(
      breadcrumbsSearch
    )
    const breadcrumbsSubfieldsArr =
      selectedBreadcrumbs.length &&
      selectedBreadcrumbs.map((value, index) => {
        return {
          index: index,
          value: value.key,
          title: value.title
        }
      })

    return breadcrumbsSubfieldsArr || []
  }

  setBreadcrumbsSubfields = searchParameter => {
    this.setState({
      breadcrumbsSearch: searchParameter,
      breadcrumbsSubfields: searchParameter
        ? this.getBreadcrumbsSubfields()
        : []
    })
  }

  updateBreadcrumbsSubfields = subfield => {
    if (subfield.index === 0) {
      this.setState({ breadcrumbsSubfieldIndex: 1 })
      this.setState({ breadcrumbsSubfields: [subfield] })

      return
    }

    const { breadcrumbsSubfields } = this.state
    const copySubfields = [...breadcrumbsSubfields]
    const existingIndex = copySubfields.findIndex(
      item => item.index === subfield.index
    )

    if (existingIndex > -1) {
      copySubfields.splice(existingIndex)
    }

    this.setState({ breadcrumbsSubfieldIndex: subfield.index })
    this.setState({ breadcrumbsSubfields: [...copySubfields, subfield] })
  }

  removeBreadcrumbsSubfield = index => {
    const { breadcrumbsSubfieldIndex, breadcrumbsSubfields } = this.state

    if (breadcrumbsSubfieldIndex === index) {
      this.setState({ breadcrumbsSubfieldIndex: 1 })
    }

    this.setState({ breadcrumbsSubfieldIndex: index + 1 })
    this.setState({
      breadcrumbsSubfields: [...breadcrumbsSubfields].slice(0, index)
    })
  }

  render() {
    const { name } = this.props
    const { breadcrumbsSubfields } = this.state

    return (
      <ul
        className="c-results-filters__list menu vertical nested"
        style={getStyles("c-results-filters__list")}
      >
        <li
          className="c-results-filters__single-block"
          style={getStyles("c-results-filters__single-block")}
        >
          <BreadcrumbsDropdown
            filterName={name}
            subfieldIndex={0}
            breadcrumbOptions={this.getBreadcrumbsOptions(name)}
            selectedType={breadcrumbsSubfields[0] && breadcrumbsSubfields[0]}
            subfields={breadcrumbsSubfields}
            updateSubfields={this.updateBreadcrumbsSubfields}
            removeSubfield={this.removeBreadcrumbsSubfield}
          />
        </li>

        {breadcrumbsSubfields.map(({ index, value }) => (
          <li
            key={value}
            className="c-results-filters__single-block"
            style={getStyles("c-results-filters__single-block")}
          >
            <BreadcrumbsDropdown
              filterName={name}
              subfieldIndex={index + 1}
              selectedType={
                breadcrumbsSubfields[index + 1] &&
                breadcrumbsSubfields[index + 1]
              }
              subfields={breadcrumbsSubfields}
              updateSubfields={this.updateBreadcrumbsSubfields}
              removeSubfield={this.removeBreadcrumbsSubfield}
            />
          </li>
        ))}
      </ul>
    )
  }
}

export default injectIntl(FilterBreadcrumbs)



// WEBPACK FOOTER //
// ./webapp/components/elements/FilterBreadcrumbs.js